import React from 'react';

const base = 'cooking-v2';

const normalizeLocation = (location) => {
    const rawLocation = (location || 'Warmer').trim();

    return rawLocation
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .replace(/\b\w/g, (char) => char.toUpperCase());
};

export default function InstaServiceCurrentStock({ currentWarmerStocks = [] }) {
    const groupedByLocation = currentWarmerStocks.reduce((acc, entry) => {
        const location = normalizeLocation(entry.insta_service_location);
        if (!acc[location]) {
            acc[location] = [];
        }
        acc[location].push(entry);
        return acc;
    }, {});

    const allLocations = Object.keys(groupedByLocation);
    const fixedOrder = ['Warmer', 'Sous Vide', 'Chiller'];
    const otherLocations = allLocations.filter((location) => !fixedOrder.includes(location));
    const locations = [...fixedOrder, ...otherLocations.sort()];

    const groupedData = locations.map((location) => {
        const entries = groupedByLocation[location] || [];

        const groupedByCategory = entries.reduce((acc, entry) => {
            const { category } = entry;
            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(entry);
            return acc;
        }, {});

        const categories = Object.keys(groupedByCategory)
            .map((category) => ({
                category,
                items: groupedByCategory[category].sort((a, b) => b.quantity - a.quantity),
            }))
            .sort((a, b) => b.items.length - a.items.length);

        return { location, categories };
    });
    const hasAnyStock = groupedData.some(({ categories }) => categories.length > 0);

    return (
        <div>
            <div className={`${base}__insta_service_panel_body ${base}__insta_service_panel_body_stock`}>
                <div className={`${base}__insta_service_stock_grid`}>
                    {groupedData.map(({ location, categories }) => {
                        const locationKey = location.toLowerCase().replace(/\s+/g, '-');

                        return (
                            <div
                                key={location}
                                className={`${base}__insta_service_stock_location_card ${base}__insta_service_stock_location_card--${locationKey}`}
                            >
                                <h4
                                    className={`${base}__insta_service_stock_location_title ${base}__insta_service_stock_location_title--${locationKey}`}
                                >
                                    {`IN ${location.toUpperCase()}`}
                                </h4>
                                {categories.length > 0 ? (
                                    categories.map((category) => (
                                        <div
                                            className={`${base}__insta_service_stock_category`}
                                            key={`${location}-${category.category}`}
                                        >
                                            <div className={`${base}__insta_service_stock_category_name`}>
                                                {category.category}
                                            </div>
                                            {category.items.map((item, index) => (
                                                <div
                                                    className={`${base}__insta_service_stock_item`}
                                                    key={`${location}-${category.category}-${item.sku || item.name || index}`}
                                                >
                                                    <span className={`${base}__insta_service_stock_item_name`}>
                                                        {item.name || ''}
                                                    </span>
                                                    <div className={`${base}__insta_service_stock_item_right`}>
                                                        <span className={`${base}__insta_service_stock_item_qty`}>
                                                            {item.quantity}
                                                        </span>
                                                        {item.oos && (
                                                            <p className={`${base}__oos-tag`}>OOS</p>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))
                                ) : (
                                    <p className={`${base}__insta_service_empty_state`}>
                                        No items
                                    </p>
                                )}
                            </div>
                        );
                    })}
                </div>
                {!hasAnyStock && (
                    <p className={`${base}__insta_service_empty_state`}>
                        No items across locations
                    </p>
                )}
            </div>
        </div>
    );
}
